<nb-card class="dialog-modal-card">
    <nb-card-header>{{ title }}</nb-card-header>
    <nb-card-body>
        {{body}}
    </nb-card-body>
    <nb-card-footer>
        <button nbButton status="success" (click)="submit(true)">{{btnAccept}}</button>
        <button nbButton status="danger" (click)="dismiss()">{{btnCancel}}</button>
    </nb-card-footer>
</nb-card>